function deactiveComments(state) {
  return state.map(comment => {
    if (comment.isActive) {
      return { ...comment, isActive: false };
    } else {
      return comment;
    }
  });
}

export default class CommentsReducer {
  constructor({
    viewMode,
    currentBreakPoint,
    documentServices,
    pageId,
    isSiteResponsive,
  }) {
    this.viewMode = viewMode;
    this.currentBreakPoint = currentBreakPoint;
    this.isSiteResponsive = isSiteResponsive;
    this.documentServices = documentServices;
    this.pageId = pageId;
  }

  reducer(state, action) {
    switch (action.type) {
      case 'SET_COMMENTS': {
        return [...action.comments];
      }
      case 'DELETE_REPLY_TO_COMMENT': {
        const { commentId, replyId } = action;
        return state.map(comment => {
          if (comment.id === commentId) {
            const replies = comment.replies.filter(({ id }) => id !== replyId);
            return { ...comment, ...{ replies } };
          } else {
            return comment;
          }
        });
      }
      case 'UPDATE_COMMENT': {
        return state.map(comment => {
          if (comment.id === action.id) {
            return { ...comment, ...action.changes };
          } else {
            return comment;
          }
        });
      }
      case 'UPDATE_REPLY_TO_COMMENT': {
        const { commentId, replyId } = action;
        return state.map(comment => {
          if (comment.id === commentId) {
            comment.replies = comment.replies.map(reply => {
              if (reply.id === replyId) {
                return { ...reply, ...action.changes };
              } else {
                return reply;
              }
            });
            return comment;
          } else {
            return comment;
          }
        });
      }
      case 'OPEN_COMMENT': {
        return state.map(comment => {
          if (comment.id === action.id) {
            return { ...comment, isActive: true, keepPopupOpen: true };
          } else {
            return comment;
          }
        });
      }
      case 'DE_ACTIVATE_COMMENTS': {
        return deactiveComments(state);
      }
      default:
        return state;
    }
  }
}
